import type { IQuickFilter } from "../../components/Organismos/Table/FilteredTable.types";

export type AccountingTab = "accountingAll" | "annualDues" | "assessmentDues";

export const ACCOUNTING_TABS: IQuickFilter[] = [
  { key: "accountingAll", label: "Accounting (All)" },
  { key: "annualDues", label: "Annual Dues" },
  { key: "assessmentDues", label: "Assessment Dues" },
];

export const STATS_TABS: ReadonlySet<AccountingTab> = new Set([
  "accountingAll",
  "annualDues",
]);

export function isAccountingTab(value: unknown): value is AccountingTab {
  return (
    typeof value === "string" &&
    ACCOUNTING_TABS.some((tab) => tab.key === value)
  );
}
